
import React from "react";

interface MobileLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  headerTitle?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
  rightContent?: React.ReactNode;
  showBottomNav?: boolean;
  hideNavigation?: boolean;
  pageHeaderProps?: any;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  // Legacy props are accepted but ignored to maintain compatibility
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/20 to-slate-950">
      <main className="relative">
        {children}
      </main>
    </div>
  );
};

export default MobileLayout;
